import * as React from 'react';
import { useMapDisplayContext } from '../MapDisplayContext';
import { OpenLayersPinMarker } from './OpenLayersPinMarker';
import { Map } from 'ol';
import { ReduxState } from 'ducks';
import { useSelector } from 'react-redux';
import { getFilteredPins } from '../util';
import { useUrlQueryDisplayState } from '../useUrlQueryDisplayState';
import { useStarredPins } from 'hooks/useStarredPins';

export interface Props {
  map: Map;
  onClickPin: (pinKey: string) => void;
}

export const OpenLayersPins: React.FC<Props> = ({ map, onClickPin }) => {
  const { activePinKey } = useUrlQueryDisplayState();

  const { searchText, selectedFloor, activeItineraryPinKeys, activePage } = useMapDisplayContext();
  const { filters } = useUrlQueryDisplayState();
  const digitalMap = useSelector((state: ReduxState) => state.universal.digitalMap.map);
  const { isStarred } = useStarredPins();

  const filteredPins = React.useMemo(
    () =>
      getFilteredPins(
        digitalMap?.pins ?? [],
        filters,
        searchText,
        (digitalMap?.map_floor_count ?? 0) > 1 ? selectedFloor : undefined,
        isStarred
      ),
    [digitalMap, filters, searchText, selectedFloor, isStarred]
  );

  return (
    <>
      {filteredPins.map((pin) => (
        <OpenLayersPinMarker
          key={pin.index}
          map={map}
          pin={pin}
          isActive={
            activePage === 'ITINERARIES.CREATE' || activePage === 'ITINERARIES.EDIT_DETAILS'
              ? activeItineraryPinKeys.includes(pin.key)
              : activePinKey === pin.key
          }
          onClick={onClickPin}
        />
      ))}
    </>
  );
};
